import { render, staticRenderFns } from "./ConSume.vue?vue&type=template&id=6b0afbcc&scoped=true&"
import script from "./ConSume.vue?vue&type=script&lang=js&"
export * from "./ConSume.vue?vue&type=script&lang=js&"
import style0 from "./ConSume.vue?vue&type=style&index=0&id=6b0afbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0afbcc",
  null
  
)

export default component.exports